import config from '../config';
import { ActionTypes as actions, PracticeActions, ToastActions } from '../actions';
import { History as history, Routes as routes } from '../navigation';
import axios from 'axios';

const displayError = (message, data) => {
  return dispatch => {
    var errorMessage = '';
    if (data) {
      errorMessage = data.error && data.error.message ? data.error.message : '';
    }
    if (message) {
      errorMessage = message;
    }
    dispatch(ToastActions.displayError(errorMessage));
  }
}

const connectClientToPractice = (token) => {
  return dispatch => {
    const userProviderObject = {
      user_id: '5caceec36156d014201892ae',
      practice_id: '5c9d041e5b9475f92364e689',
      provider_id: "5c9d041e5b9475f92364e687",
      provider_location_id: "5c9d041e5b9475f92364e68a",
    }

    fetch(`${config.BASE_URL}/api/user/provider`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'authorization': token,
      },
      body: JSON.stringify(userProviderObject)
    })
    .then((res) => {
      return res.json()
    })
    .then((body) => {
      console.log("IN BODY");
      console.log(body);
    })
    .catch(error => {
      console.log("IN ERROR")
      console.log(error)
    });

  }
}

const getProviders = (token, user_id) => {
  return dispatch => {
    fetch(`${config.BASE_URL}/api/user/provider/${user_id}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'authorization': token,
      }
    })
    .then((res) => {
      return res.json()
    })
    .then((body) => {
      console.log("GET PROVIDERS");
      console.log(body);
      const userProviderObject = body.data[0];
      console.log("User Provider")
      console.log(userProviderObject)
    })
    .catch(error => {
      console.log("IN ERROR")
      console.log(error)
    });
  }
}

const editConsultation = (token, consultationInfo) => {
  return dispatch => {

    fetch(`${config.BASE_URL}/api/consultation/${consultationInfo._id}`, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'authorization': token,
      },
      body: JSON.stringify(consultationInfo)
    })
    .then((res) => {
      return res.json();
    })
    .then((body) => {
      console.log("Edit Consult")
      console.log(body);
    })
    .catch(error => {
      console.log("Error:")
      console.log(error)
    });

  }
}

const startRecordingComposition = (token, consultation_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/consultation/video/complete/${consultation_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};

    }).catch((error) => { console.log(error) });

  }
}

const getRecordingComposition = (token, consultation_id) => {
    return dispatch => {

      const requestURL = `${config.BASE_URL}/api/consultation/video/recordings/${consultation_id}`;
      const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

      axios.get(requestURL, requestConfig).then((response) => {
        const data = response.data || {};

      }).catch((error) => { console.log(error) });

    }
}

const openConsultation = (token, consultation) => {
  return dispatch => {

    dispatch(getConsultationParticipants(token, consultation._id));
    dispatch(switchConsultationTab('messages'));
    dispatch({
      type: actions.CONSULTATION_SELECTED_UPDATE,
      payload: consultation
    })
    history.push(routes.CONSULTATION);
  }
}

const switchConsultationTab = (tab) => {
  return dispatch => {

    dispatch({
      type: actions.CONSULTATION_SELECTED_TAB,
      payload: tab
    })

  }
}

const getConsultationParticipantUserInfo = (user_id, token) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/consultation/participant_info/${user_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const user = data.user;
      if (user) {
        dispatch({
          type: actions.USER_ADD_USER,
          payload: user
        });
      }
    }).catch((error) => { console.log(error) });

  }
}

const getConsultationParticipants = (token, consultation_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/consultation/participants/${consultation_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data;
      const participants = data.participants || [];

      if (participants.length > 0) {
        participants.forEach((participant) => {
          dispatch(getConsultationParticipantUserInfo(participant._id, token))
        })
      }

      const participantsObj = {
        consultation_id: consultation_id,
        participants: participants,
      }

      dispatch({
        type: actions.CONSULTATION_UPDATE_PARTICIPANTS,
        payload: participantsObj
      })
    }).catch((error) => { console.log(error) });

  }
}

const addConsultationParticipant = (token, consultation_id, participant_id, successCallback) => {
  return dispatch => {

    const participantObject = {
      participant: participant_id,
      consultation_id: consultation_id,
      is_provider_side: true,
      is_client_side: false,
      can_contribute: true,
    }

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/consultation/participants`;

    axios.post(requestURL, JSON.stringify(participantObject), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        dispatch(getConsultationParticipants(token, consultation_id));
        dispatch(ToastActions.displayInfo('Participant Added to Consultation'));
        if (successCallback) {
          successCallback();
        }
      }
    }).catch((error) => { console.log(error) });

  }
}

const removeConsultationParticipant = (token, consultation_id, participantObject) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/consultation/participants/${participantObject._id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.delete(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success) {
        dispatch(getConsultationParticipants(token, consultation_id));
      }
    }).catch((error) => { console.log(error) });

  }
}

const fetchOpenConsultationMessages = (token, consultationID, successCallback) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/consultation/${consultationID}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const messages = data.messages || [];
      if (data.success === true) {
        successCallback(messages)
      }
    }).catch((error) => { console.log(error) });

  }
}

const updateConsultation = (token, consultation, successCallback) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/consultation/${consultation._id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.put(requestURL, JSON.stringify(consultation), requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success === true) {
        dispatch(PracticeActions.getPracticeActiveConsultations(token, consultation.practice_id));
        if (successCallback) {
          successCallback();
        }
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const searchClientsAndPatients = (token, searchTerm, practice_id, callBack) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/consultation/practice_client_search/${searchTerm}/${practice_id}/${1}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data  = response.data || {};
      const users = data.users || [];
      if (data.success === true) {
        callBack(users);
      }
    }).catch((error) => { console.log(error) });

  }
}

const createNewConsultation = (token, consultation, callBack) => {
  return (dispatch, getState) => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/consultation`;
    const user_id = getState().user.auth.user_id;

    axios.post(requestURL, JSON.stringify(consultation), requestConfig).then((response) => {
      const data = response.data;

      if (data.success) {
        dispatch(getRefreshedConsultations(true));
        if (callBack) {
          callBack();
        }
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const getConsultationInfo = (token, consultationID) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/consultation/${consultationID}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const consultationInfo = data.details;
      if (data.success) {
        dispatch(PracticeActions.getPracticeClientUserInfo(token, consultationInfo.primary_client));
        dispatch(PracticeActions.getPracticePatientInfo(consultationInfo.patient_id, token));
        dispatch({ type: actions.CONSULTATION_ADD_CONSULTATION_DETAIL, payload: consultationInfo });
      }
    }).catch((error) => { console.log(error) });

  }
}

const resolveConsultation = (token, consultation_id, params, callBack) => {
  return dispatch => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/consultation/resolve/${consultation_id}`;
    dispatch({ type: actions.LOADING_RESOLVE_CONSULTATION, payload: true });

    axios.post(requestURL, JSON.stringify(params), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        dispatch(ToastActions.displayInfo('Consultation Resolved'));
        if (callBack) {
          callBack();
        }
      } else { dispatch(displayError(data.message && data.message.message ? data.message.message : '')) }
      dispatch({ type: actions.LOADING_RESOLVE_CONSULTATION, payload: false });
    }).catch((error) => {
      dispatch(displayError(error))
      dispatch({ type: actions.LOADING_RESOLVE_CONSULTATION, payload: false });
    });

  }
}

const sendTaskToFrontDesk = (token, task, callBack) => {
  return dispatch => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/front_desk/add`;

    axios.post(requestURL, JSON.stringify(task), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        dispatch(ToastActions.displayInfo('Task Sent to Front Desk'));
        if (callBack) {
          callBack();
        }
      } else { dispatch(displayError('', data)) }
    }).catch((error) => { dispatch(displayError(error)) });

  }
}

const createMedicalRecord = (token, record, callBack) => {
  return dispatch => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/patient/medical_records`;

    axios.post(requestURL, JSON.stringify(record), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        dispatch(ToastActions.displayInfo('Medical Record Created'));
        if (callBack) {
          callBack();
        }
      } else { dispatch(displayError('', data)) }
    }).catch((error) => { dispatch(displayError(error)) });

  }
}

const getConsultationMedicalRecords = (token, consultation_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/patient/medical_records/consultation/${consultation_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data    = response.data || {};
      const records = data.data || [];

      if (data.success === true) {
        const recordsData = {
          consultation_id: consultation_id,
          data: records,
        }
        dispatch({ type: actions.CONSULTATION_UPDATE_CONSULTATION_RECORDS, payload: recordsData });
      }
    }).catch((error) => { console.log(error) });

  }
}

const getConsultationFrontDeskTasks = (token, consultation_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/front_desk/consultation/${consultation_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data  = response.data || {};
      const tasks = data.tasks || [];

      if (data.success === true) {
        const tasksData = {
          consultation_id: consultation_id,
          data: tasks,
        }
        dispatch({ type: actions.CONSULTATION_UPDATE_CONSULTATION_TASKS, payload: tasksData });
      }
    }).catch((error) => { console.log(error) });

  }
}

const getVideoRooms = (token, consultation_id, callback) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/api/consultation/video/room/${consultation_id}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      let data = response.data || {};
      let room = data.roomObject;
      let compositions = data.compositions || [];

      if (data.success) {
        let recording_data = {
          room: room,
          compositions: compositions,
        }
        callback(recording_data);
      }

    }).catch((error) => { console.log(error) })

  }
}

const startProcessingComposition = (token, consultation_id, callback) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/api/consultation/video/complete/${consultation_id}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};

      if (data.success) {
        let rooms_arr = data && data.rooms        ? data.rooms : [];
        let comps_arr = data && data.compositions ? data.compositions : [];
        if (rooms_arr.length === 0 && comps_arr.length === 0) {
          dispatch(ToastActions.displayInfo('Video Recordings are not ready for processing yet. Please try again in a few minutes. It takes a few mintues after the conclusion of a session for the videos to be ready for processing.'));
        }
        callback(true);
      } else {
        callback(false);
        dispatch(ToastActions.displayError('No video data avaiable for this session'));
      }

    }).catch((error) => {
      callback(false);
      dispatch(ToastActions.displayError('Error retrieving data avaiable for this session'));
      console.log(error)
     })

  }
}

const getRoomVideoBuffer = (token, room_id, callback) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/api/consultation/video/get_video_buffer/${room_id}`;
    let requestConfig = { headers: { 'authorization': token }, responseType: "blob" }

    axios.get(requestURL, requestConfig).then((response) => {
      let data = response.data || {};

      if (data) {
        callback(data)
      }

    }).catch((error) => { console.log(error) })

  }
}

const getProviderRolesAndLocations = (token, user_id, practice_id, roles_callback, locations_callback) => {
  return dispatch => {

    let loc_request_url    = `${config.BASE_URL}/api/user/practice/location/${user_id}`;
    let loc_request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    let roles_request_url    = `${config.BASE_URL}/api/user/user_roles/${user_id}`;
    let roles_request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(loc_request_url, loc_request_config).then((response) => {
      let data      = response.data || {};
      let locations = data.data     || [];
      if (data.success === true && locations_callback) {
        let filtered_locations = locations.map((location) => {
          if (location.practice_id === practice_id) {
            return location;
          }
        }).filter((r) => { return r });
        locations_callback(filtered_locations);
      }
    }).catch((error) => { console.log(error) });

    axios.get(roles_request_url, roles_request_config).then((response) => {
      let data = response.data || {};
      let roles = data.roles || [];
      if (roles_callback) {
        let filtered_roles = roles.map((role) => {
          if (role.practice_id === practice_id) {
            return role;
          }
        }).filter((r) => { return r });
        roles_callback(filtered_roles);
      }

    }).catch((error) => { console.log(error) })

  }
}

const clientSearch = (token, location_id, practice_id, search_term, callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/consolidated/client_search/${location_id}/${practice_id}/${search_term}`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(request_url, request_config).then((response) => {
      let data    = response.data || {};
      let clients = data.clients  || [];

      if (data) {
        callback(clients)
      }

    }).catch((error) => { console.log(error) })

  }
}

const getClientPatients = (token, user_id, callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/consolidated/patients_client/${user_id}`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(request_url, request_config).then((response) => {
      let data     = response.data || {};
      let patients = data.patients || [];

      if (data) {
        callback(patients)
      }

    }).catch((error) => { console.log(error) })

  }
}

const getPracticeVeterinarians = (token, location_id, practice_id, callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/consolidated/providers/${location_id}/${practice_id}`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(request_url, request_config).then((response) => {
      let data      = response.data || {};
      let providers = data.providers || [];

      if (data) {
        let eligible_providers = [];
        providers.forEach((provider, i) => {
          let roles   = provider.user_roles || [];
          let prac_id = practice_id;
          roles.forEach((role, i) => {
            let p_id        = role && role.practice_id ? role.practice_id   : '';
            let is_eligible = role && (role.vet || role.behaviorist) ? true : false;
            if (is_eligible && p_id === practice_id) {
              eligible_providers.push(provider);
            }
          });
        });
        callback(eligible_providers)
      }

    }).catch((error) => { console.log(error) })

  }
}

const getPracticeConsultations = (token, consultation_status, is_preview, page_num, sort_by, practice_id, location_id) => {
  return (dispatch, getState) => {

    let current_status    = getState().consultations.seeAllConsultationsStatus
    let status            = consultation_status || 'ACTIVE';
    let page_number_index = page_num ? page_num - 1 : 0;
    let items_per_page    = is_preview ? 5 : 10;
    let default_sort_by   = status === 'ACTIVE' ? 'created_at' : 'updated_at';
    let sort_by_filter    = sort_by || default_sort_by;

    let page_state        = getState().consultations.seeAllConsultationsPageState ? getState().consultations.seeAllConsultationsPageState : {};
    let search_term       = page_state && page_state.search_term ? page_state.search_term : '';
    let search_by         = page_state && page_state.search_by   ? page_state.search_by   : '';

    let request_url    = `${config.BASE_URL}/api/consultation/consultation_detail/practice/${status}/${page_number_index}/${items_per_page}/${sort_by_filter}/${practice_id}`;
        request_url    = location_id ? `${config.BASE_URL}/api/consultation/consultation_detail/practice/${status}/${page_number_index}/${items_per_page}/${sort_by_filter}/${practice_id}/${location_id}` : request_url;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    if (search_term && search_by && !is_preview) {
        request_url    = `${config.BASE_URL}/api/consultation/consultation_detail/practice/${status}/${page_number_index}/${items_per_page}/${sort_by_filter}/${practice_id}/null/${search_term}/${search_by}`;
        request_url    = location_id ? `${config.BASE_URL}/api/consultation/consultation_detail/practice/${status}/${page_number_index}/${items_per_page}/${sort_by_filter}/${practice_id}/${location_id}/${search_term}/${search_by}` : request_url;
    }

    axios.get(request_url, request_config).then((response) => {
      let data          = response.data || {};
      let consultations = data.consultations || [];

      if (data.success === true) {

        if (is_preview) {
          let state = getState();
          let existing_previews     = state && state.consultations && state.consultations.previewConsultations ? Object.assign({}, state.consultations.previewConsultations) : {};
          existing_previews[status] = consultations;
          dispatch({ type: actions.CONSULTATION_UPDATE_PREVIEWS, payload: existing_previews });
        } else {
          let state            = getState();
          let existing_see_all = consultations;
          dispatch({ type: actions.CONSULTATION_UPDATE_SEE_ALL, payload: existing_see_all });
        }

      }
    }).catch((error) => { console.log(error) });

  }
}

const getUserConsultations = (token, consultation_status, is_preview, page_num, sort_by, prac_id, loc_id) => {
  return (dispatch, getState) => {

    let status            = consultation_status || 'ACTIVE';
    let page_number_index = page_num ? page_num - 1 : 0;
    let items_per_page    = is_preview ? 5 : 10;
    let sort_by_filter    = sort_by || 'updated_at';
    let practice_id       = prac_id || '';
    let location_id       = loc_id  || '';

    let page_state        = getState().consultations.seeAllConsultationsPageState ? getState().consultations.seeAllConsultationsPageState : {};
    let search_term       = page_state && page_state.search_term ? page_state.search_term : '';
    let search_by         = page_state && page_state.search_by   ? page_state.search_by   : '';

    let request_url    = `${config.BASE_URL}/api/consultation/consultation_detail/user/${status}/${page_number_index}/${items_per_page}/${sort_by_filter}`;
        request_url    = practice_id !== '' ? `${config.BASE_URL}/api/consultation/consultation_detail/user/${status}/${page_number_index}/${items_per_page}/${sort_by_filter}/${practice_id}` : request_url;
        request_url    = location_id !== '' ? `${config.BASE_URL}/api/consultation/consultation_detail/user/${status}/${page_number_index}/${items_per_page}/${sort_by_filter}/${practice_id}/${location_id}` : request_url;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    if (search_term && search_by && !is_preview) {
        request_url    = `${config.BASE_URL}/api/consultation/consultation_detail/user/${status}/${page_number_index}/${items_per_page}/${sort_by_filter}/null/null/${search_term}/${search_by}`;
        request_url    = practice_id ? `${config.BASE_URL}/api/consultation/consultation_detail/user/${status}/${page_number_index}/${items_per_page}/${sort_by_filter}/${practice_id}/null/${search_term}/${search_by}` : request_url;
        request_url    = location_id ? `${config.BASE_URL}/api/consultation/consultation_detail/user/${status}/${page_number_index}/${items_per_page}/${sort_by_filter}/${practice_id}/${location_id}/${search_term}/${search_by}` : request_url;
    }

    axios.get(request_url, request_config).then((response) => {
      let data          = response.data || {};
      let consultations = data.consultations || [];

      if (data.success === true) {

        if (is_preview) {
          let state = getState();
          let existing_previews     = state && state.consultations && state.consultations.previewConsultations ? Object.assign({}, state.consultations.previewConsultations) : {};
          existing_previews[status] = consultations;
          dispatch({ type: actions.CONSULTATION_UPDATE_PREVIEWS, payload: existing_previews });
        } else {
          let state            = getState();
          let existing_see_all = consultations;
          dispatch({ type: actions.CONSULTATION_UPDATE_SEE_ALL, payload: existing_see_all });
        }

      }
    }).catch((error) => { console.log(error) });

  }
}

const getAllConsultations = (passed_status, page_number) => {
  return (dispatch, getState) => {

    let state         = getState();
    let context       = state.context      || {};
    let token         = state.user && state.user.auth && state.user.auth.token ? state.user.auth.token : '';
    let consultation  = state.consultations || {}
    let user_role     = context.selectedRole     || '';
    let practice_id   = context.selectedPractice || '';
    let location_id   = context.selectedLocation || '';
    let curr_page_num = state.consultations && state.consultations.seeAllConsultationsPageState && state.consultations.seeAllConsultationsPageState.page_number ? state.consultations.seeAllConsultationsPageState.page_number : 1;
    let next_page     = page_number   || curr_page_num;
    let curr_status   = state.consultations && state.consultations.seeAllConsultationsStatus ? state.consultations.seeAllConsultationsStatus : 'ACTIVE';
    let status        = passed_status || curr_status;
    let sort_category = status === 'ACTIVE' ? 'created_at' : 'updated_at';

    dispatch({ type: actions.CONSULTATION_UPDATE_SEE_ALL_STATUS, payload: status });

    if (user_role === 'admin' || user_role === 'practice_manager' || user_role === 'practice_owner') {
      dispatch(getPracticeConsultations(token, status, false, next_page, sort_category, practice_id));
    } else if (user_role === 'front_desk') {
      dispatch(getPracticeConsultations(token, status, false, next_page, sort_category, practice_id, location_id));
    } else {
      dispatch(getUserConsultations(token, status, false, next_page, sort_category, practice_id, location_id));
    }

  }
}

const updateConsultationsScreenStatus = (passed_status, page_number) => {
  return (dispatch, getState) => {

    let state       = getState();
    let page_state  = state && state.consultations && state.consultations.seeAllConsultationsPageState ? state.consultations.seeAllConsultationsPageState : { page_number: 1 };
    let page_num    = page_number || page_state.page_number;
    let curr_status = state.consultations && state.consultations.seeAllConsultationsStatus ? state.consultations.seeAllConsultationsStatus : 'ACTIVE';
    let status      = passed_status || curr_status;

    page_state.page_number = page_num;

    dispatch(getAllConsultations(status, page_state.page_number));
    dispatch({ type: actions.CONSULTATION_UPDATE_SEE_ALL_STATUS,     payload: status     });
    dispatch({ type: actions.CONSULTATION_UPDATE_SEE_ALL_PAGE_STATE, payload: page_state });
  }
}

const setConsultationSearchFilter = (search_term, search_by) => {
  return (dispatch, getState) => {

    let state       = getState();
    let page_state  = state && state.consultations && state.consultations.seeAllConsultationsPageState ? state.consultations.seeAllConsultationsPageState : { page_number: 1 };

    if (search_term && search_by) {
      page_state  = { page_number: page_state.page_number, search_term: search_term, search_by: search_by }
    } else {
      page_state  = { page_number: 1 };
    }

    dispatch({ type: actions.CONSULTATION_UPDATE_SEE_ALL_PAGE_STATE, payload: page_state });
    dispatch(getAllConsultations('', 1));

  }
}

const getPracticePreviewConsultations = (token, status, practice_id) => {
  return (dispatch, getState) => {
    let sort_category = status === 'ACTIVE' ? 'created_at' : 'updated_at';
    let state         = getState();
    let context       = state.context            || {};
    let location_id   = context.selectedLocation || '';
    dispatch(getPracticeConsultations(token, status, true, 1, sort_category, practice_id, location_id));
  }
}

const getUserPreviewConsultations = (token, status) => {
  return (dispatch, getState) => {
    let sort_category = status === 'ACTIVE' ? 'created_at' : 'updated_at';

    let state         = getState();
    let context       = state.context || {};
    let practice_id   = context.selectedPractice || '';
    let location_id   = context.selectedLocation || '';

    dispatch(getUserConsultations(token, status, true, 1, sort_category, practice_id, location_id));
  }
}

const getRefreshedConsultations = (preview_only) => {
  return (dispatch, getState) => {

    let state         = getState();
    let context       = state.context      || {};
    let token         = state.user && state.user.auth && state.user.auth.token ? state.user.auth.token : '';
    let consultation  = state.consultation || {};
    let user_role     = context.selectedRole     || '';
    let practice_id   = context.selectedPractice || '';

    if (user_role === 'admin' || user_role === 'practice_manager' || user_role === 'practice_owner' || user_role === 'front_desk') {
      dispatch(getPracticePreviewConsultations(token, 'ACTIVE', practice_id));
      dispatch(getPracticePreviewConsultations(token, 'UNASSIGNED', practice_id));
      dispatch(getPracticePreviewConsultations(token, 'RESOLVED', practice_id));
      dispatch(getPracticePreviewConsultations(token, 'PROCESSING', practice_id));
    } else {
      dispatch(getUserPreviewConsultations(token, 'ACTIVE'));
      dispatch(getUserPreviewConsultations(token, 'RESOLVED'));
    }

    let see_all_status = consultation.seeAllConsultationsStatus || '';

    if (see_all_status && preview_only !== true) {
      dispatch({ type: actions.CONSULTATION_UPDATE_SEE_ALL, payload: null });
      dispatch(getAllConsultations(see_all_status, 1));
    }

  }
}

const updateConsultationsScreenState = (state_values) => {
  return dispatch => {

    dispatch({ type: actions.CONSULTATIONS_SCREEN_STATE_UPDATE, payload: state_values });

  }
}

export default {
  addConsultationParticipant,
  clientSearch,
  removeConsultationParticipant,
  editConsultation,
  fetchOpenConsultationMessages,
  createNewConsultation,
  connectClientToPractice,
  getProviders,
  openConsultation,
  updateConsultation,
  getClientPatients,
  getAllConsultations,
  getPracticePreviewConsultations,
  getPracticeConsultations,
  getConsultationMedicalRecords,
  getConsultationFrontDeskTasks,
  getPracticeVeterinarians,
  getRefreshedConsultations,
  getUserPreviewConsultations,
  searchClientsAndPatients,
  getConsultationInfo,
  getVideoRooms,
  startProcessingComposition,
  getRoomVideoBuffer,
  sendTaskToFrontDesk,
  setConsultationSearchFilter,
  resolveConsultation,
  switchConsultationTab,
  createMedicalRecord,
  startRecordingComposition,
  getRecordingComposition,
  updateConsultationsScreenStatus,
  updateConsultationsScreenState,
  getProviderRolesAndLocations,
}
